export default [
  [5, 11],
  [10, 21],
  [20, 41],
  [40, 81],
  [80, 161],
  [160, 321],
  [320, 641],
  [640, 1281],
  [1280, 2561],
  [2560, 5121],
  [5120, 10241],
  [10240, 20481],
  [20480, 40961],
  [40960, 81921],
  [81920, 163841],
  [163840, 327681],
  [327680, 655361],
  [655360, 1310721],
  [1310720, 100000000000]
];
